export const isEnumValue = <T extends object>(
  enumObj: T,
  value: any // eslint-disable-line @typescript-eslint/no-explicit-any
): value is T[keyof T] => {
  return Object.values(enumObj).includes(value);
};
